import { css } from 'styled-components'

export const fade = (time = 1) => css`
  animation: fade ${time}s ease-in-out;
  transition: transform ${time}s;

  @keyframes fade {
    0% {
      opacity: 0;
    }
  }
`
